import React, { Component } from "react";
import AddNewEvent from "./AddNewEvent";
import EventList from "./EventList";

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectType: 0
    };
  }

  changeStatus = type => {
    this.setState({
      selectType: type
    });
  };

  render() {
    const { selectType } = this.state;
    return (
      <div className="wrapper position-relative">
        
        {selectType == 0 ? (
          <EventList changeStatus={this.changeStatus} />
        ) : (
          <AddNewEvent  changeStatus={this.changeStatus} />
            )}
        </div>
    );
  }
}
